import StorageAutomation from './StorageAutomation';
export default StorageAutomation;
